export const UPDATE_MESSAGE_RECEIVED = 'UPDATE_MESSAGE_RECEIVED';
export const WS_UPDATE_CALL_MESSAGE_RECEIVED =
  'WS_UPDATE_CALL_MESSAGE_RECEIVED';
export const WS_UPDATE_CALL_REASONS_MESSAGE_RECEIVED =
  'WS_UPDATE_CALL_REASONS_MESSAGE_RECEIVED';
export const WS_UPDATE_CLIENT_MESSAGE_RECEIVED =
  'WS_UPDATE_CLIENT_MESSAGE_RECEIVED';
export const WS_UPDATE_NOTE_MESSAGE_RECEIVED =
  'WS_UPDATE_NOTE_MESSAGE_RECEIVED';
export const WS_CONNECTED = 'WS_CONNECTED';
export const WS_DISCONNECTED = 'WS_DISCONNECTED';
